<template>
    <ModalFormCard :action="action" class="modal-default" :toast='"File updated"'>
        <template #title>Edit file</template>

        <template #default="{ saving, errors }">
            <Input v-model:value="value.name" groupClass="!bg-grey text-15" label="File name" name="name" />

            <Select
                v-model:value="value.folder_id"
                :options="folders"
                class="mt-4"
                label="Folder"
                menuClass="!bg-grey"
                name="folder_id"
                selectClass="!bg-grey text-15"
            />

            <Input
                v-if="value.folder_id == null"
                v-model:value="newFolder"
                class="mt-4"
                groupClass="!bg-grey text-15"
                label="New folder name"
                name="new"
            />

            <div class="grid grid-cols-1 gap-3 mt-4" v-if="deals != undefined && deals != null">
                <!-- modelId: {{ editingModel.belongs_id }} | modelType: {{ editingModel.belongs_type }} | contactId: {{ contactId }} -->

                <!-- {{ editingModel }} -->

                <CanHaveDeal
                    :contactId="contactId"
                    :modelId="editingModel.belongs_id"
                    :modelType="editingModel.belongs_type"
                    :deals="deals"
                />
            </div>

            <div class="grid grid-cols-2 pt-6 gap-4">
                <ButtonSaving :disabled="saving" class="button-black h-12 col-span-1"> Update file </ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import Deal from '~/models/deal.js'
import Upload from '~/models/upload.js'
import CanHaveDeal from '~/components/customer/blocks/can-have-deal.vue'

export default {
    mixins: [Modal],

    created() {
        this.setup(Upload)
        this.getDeals()
    },

    data() {
        return {
            newFolder: '',
            deals: this._options?.deals,
        }
    },

    methods: {
        async getDeals() {
            if (this._options == undefined || this.deals == undefined) {
                let deals = await this.$axios.get('/actions/contact-deals/' + this.contactId)
                this.deals = Deal.fill(deals.deals)
            }
        },
    },

    computed: {
        contactId() {
            if (this.editingModel != null && parseInt(this.editingModel.belongs_type) == 103) {
                // console.log(this.editingModel)
                return this.editingModel.belongs.contact_id
            }

            return this.editingModel?.belongs_id || this.modelId
        },

        canUpload() {
            if (this.folder == this.createFolders[0].value && this.newFolder == '') {
                return false
            }

            return true
        },

        folders() {
            let folders = [
                {
                    value: null,
                    html: 'Create new folder',
                },
            ]

            folders.push(
                ...this._options.folders.map((f) => {
                    return {
                        value: f.id,
                        html: this.$help.capitalizeFirstLetter(f.name),
                    }
                }),
            )

            return folders
        },
    },

    components: {
        CanHaveDeal,
    },
}
</script>
